<div class="progress">
  @if (username) {
    <div
    class="progress__username">{{ username }}</div>
  }
  @if (level && coins) {
    <div
      class="progress__data">
      <div class="progress__level">
        <span>{{ 'activities.progress_level' | translate }}&nbsp;{{ level }}</span>
      </div>
      <div class="progress__coins">
        <span>{{ coins }}</span>
        <mat-icon [svgIcon]="img"></mat-icon>
      </div>
    </div>
  }
</div>